"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const ColumnConfig_1 = tslib_1.__importDefault(require("../column-config/ColumnConfig"));
const fmko_ts_widgets_1 = require("fmko-ts-widgets");
class DateFieldColumnConfig extends ColumnConfig_1.default {
    constructor(title, headerClassName, mapDataToField, isEnabled, extraClasses) {
        super(title, headerClassName, mapDataToField);
        this.extraClasses = extraClasses;
        this.dateFields = [];
        const that = this;
        this.renderer = {
            render(ctx, obj) {
                const datefield = new fmko_ts_widgets_1.DateField({ label: "Datofelt" });
                datefield.setValue(obj.date);
                datefield.addStyleName(that.extraClasses.join(" "));
                datefield.setEnabled(isEnabled(obj.data));
                that.dateFields.push(datefield);
                ctx.setWidget(datefield);
            },
            canRender(o) {
                return true;
            }
        };
    }
    getDateFields() {
        return this.dateFields;
    }
    clear() {
        this.dateFields = [];
    }
    getData(data) {
        return { data: data, date: this.mapDataToTD(data) };
    }
}
exports.default = DateFieldColumnConfig;
//# sourceMappingURL=DateFieldColumnConfig.js.map